import React, { useEffect, useState, useMemo } from "react";
import { api, formatMinutes } from "../lib/api";

export default function Estatisticas() {
  const [stats, setStats] = useState(null);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/dashboard/stats"), api.get("/study-sessions")]).then(([s, ss]) => {
      setStats(s.data);
      setSessions(ss.data);
    });
  }, []);

  const weekly = useMemo(() => {
    const days = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (let i = 6; i >= 0; i--) {
      const d = new Date(today);
      d.setDate(today.getDate() - i);
      const iso = d.toISOString().split("T")[0];
      const total = sessions.filter((s) => s.date === iso).reduce((a, b) => a + (b.duration_minutes || 0), 0);
      days.push({ label: d.toLocaleDateString("pt-BR", { weekday: "short" }).replace(".", ""), minutes: total });
    }
    return days;
  }, [sessions]);

  const maxMin = Math.max(1, ...weekly.map((w) => w.minutes));

  if (!stats) return <div className="text-muted-foreground">Carregando...</div>;

  const maxPerDisc = Math.max(1, ...stats.per_discipline.map((d) => d.minutes));

  return (
    <div className="space-y-6 max-w-[1400px]">
      <h1 className="font-display text-3xl font-extrabold">Estatísticas</h1>

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
        <BigStat label="Tempo Total" value={formatMinutes(stats.total_minutes)} />
        <BigStat label="Questões Resolvidas" value={stats.total_questions} />
        <BigStat label="Desempenho" value={`${stats.performance}%`} tone="tiffany" />
        <BigStat label="Progresso Edital" value={`${stats.progress}%"`} tone="tiffany" />
      </div>

      <div className="rounded-2xl bg-card border border-border p-5">
        <h3 className="font-display font-bold mb-4">Estudo Semanal</h3>
        <div className="flex items-end gap-3 h-48">
          {weekly.map((w, i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-2">
              <div className="w-full flex items-end justify-center flex-1">
                <div
                  className="w-8 md:w-10 bg-tiffany-500 rounded-t-md transition-all"
                  style={{ height: `${(w.minutes / maxMin) * 100}%`, minHeight: w.minutes > 0 ? "6px" : 0 }}
                  title={formatMinutes(w.minutes)}
                />
              </div>
              <div className="text-xs text-muted-foreground capitalize">{w.label}</div>
              <div className="text-xs font-semibold">{Math.round(w.minutes / 60 * 10) / 10}h</div>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl bg-card border border-border p-5">
        <h3 className="font-display font-bold mb-4">Tempo por Disciplina</h3>
        {stats.per_discipline.length === 0 ? (
          <p className="text-muted-foreground text-sm">Adicione disciplinas para visualizar.</p>
        ) : (
          <div className="space-y-3">
            {stats.per_discipline.map((d) => (
              <div key={d.id}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-semibold" style={{ color: d.color }}>{d.name}</span>
                  <span className="text-muted-foreground">{formatMinutes(d.minutes)}</span>
                </div>
                <div className="h-2 bg-muted rounded-full overflow-hidden">
                  <div className="h-full rounded-full" style={{ width: `${(d.minutes / maxPerDisc) * 100}%`, background: d.color }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function BigStat({ label, value, tone }) {
  return (
    <div className="rounded-2xl bg-card border border-border p-5">
      <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-2">{label}</div>
      <div className={`font-display text-3xl font-extrabold ${tone === "tiffany" ? "text-tiffany-600 dark:text-tiffany-400" : ""}`}>{value}</div>
    </div>
  );
}
